import React from "react";

const SectionCard = ({ icon, title, children }) => {
  return (
    <div
      className="card p-4 mb-3"
      style={{ borderRadius: 12, border: "1px solid #F0F0F0" }}
    >
      {/* Section header */}
      <div className="d-flex align-items-center mb-4">
        {icon && (
          <span
            className="mr-2"
            style={{ fontSize: 20, color: "#262626", lineHeight: 1 }}
          >
            {icon}
          </span>
        )}
        <span
          style={{ fontWeight: 700, fontSize: 16, color: "#262626" }}
        >
          {title}
        </span>
      </div>

      {children}
    </div>
  );
};

export default SectionCard;
